module.exports = __webpack_public_path__ + "static/img/map7.6d55f90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map7.jpg
// module id = zRa6
// module chunks = 1